import { getDeliveryOptionsEndpoint } from "../../helpers";

export const FETCH_DELIVERY_DATA = "FETCH_DELIVERY_DATA";
export const RECEIVE_DELIVERY_DATA = "RECEIVE_DELIVERY_DATA";
export const FETCH_DELIVERY_DATA_ERROR = "FETCH_DELIVERY_DATA_ERROR";

function fetchDeliveryData() {
  return {
    type: FETCH_DELIVERY_DATA,
  };
}

function receiveDeliveryData(data) {
  return {
    type: RECEIVE_DELIVERY_DATA,
    deliveryData: data,
  };
}

function fetchError(err) {
  return {
    type: FETCH_DELIVERY_DATA_ERROR,
    deliveryApiError: err,
  };
}

export function fetchDelivery(country, currency, storeId) {
  return (dispatch) => {
    dispatch(fetchDeliveryData());
    const endpoint = getDeliveryOptionsEndpoint(country, currency, storeId);
    return fetch(endpoint)
      .then((response) => {
        if (response.ok) {
          return response.json();
        }
        return dispatch(fetchError(response.message));
      })
      .then((data) => {
        const deliveryData =
          data &&
          data.deliveryCountryOptions &&
          data.deliveryCountryOptions.filter((item) => item.premierIsDefault);
        if (deliveryData?.length > 1) {
          const sortedDeliveryOptions = deliveryData.sort(
            (a, b) => a.price.value - b.price.value
          );
          const defaultDeliveryOption = sortedDeliveryOptions[0];
          dispatch(receiveDeliveryData(defaultDeliveryOption));
        } else {
          dispatch(receiveDeliveryData(deliveryData?.[0]));
        }
      })
      .catch((err) => {
        dispatch(fetchError(err.message));
      });
  };
}
